export const productDataList = [
  {
    productName: "SAMSUNG Galaxy S22 5G (Phantom White, 128 GB)  (8 GB RAM)",
    price: {
      mrp: 19999,
      cost: 14199,
      discountPercent: 30,
    },
    subcategory: 'Mobile Phones',
    productImage: "/images/ban1.jpeg",
    category: 'Electronics',
    description: "Explore a new range of night photography features on this Samsung Galaxy S22 5G smartphone. You can click stunning images even in low light with the Nightography mode. It is designed with a pro-grade camera which comprises a big pixel sensor that welcomes more light for mind-blowing photography. Built with impressive software and hardware, this phone is a game-changer. With a 120 Hz refresh rate and dynamic AMOLED 2x display, you are going to experience immersive screen time. This phone operates on a Snapdragon 8 Gen 1 processor that delivers quick and hassle- free navigation. This device is protected by Corning Gorilla Glass Victus and has an IP68 waterproof rating.",
    tagline: 'New Arrival',
    quantity: 1,
    seller: "652ebf61b409f906d81645a3",
  },
];

export const bannerData = [
  { _id: 1, url: '/images/ban1.jpeg' },
  { _id: 2, url: '/images/ban2.jpeg' },
  
]